import { Checkbox } from "@msuite/ui/checkbox";
import { FileIcon } from "@msuite/ui/file-upload";
import { cn } from "@msuite/ui/utils";
import { calculateAspectRatio } from "@msuite/utils/files";
import type { ProjectGalleryItem } from "@msuite/utils/types";

/** Props Interface */
interface PickProjectGalleryFilesItemProps {
	item: ProjectGalleryItem;
	isSelected: boolean;
	onToggle: (fileId: string) => void;
}

export function PickProjectGalleryFilesItem({
	item,
	isSelected,
	onToggle,
}: PickProjectGalleryFilesItemProps) {
	/** Computed */
	const isImage = item.contentType.startsWith("image/");

	/** Render */
	return (
		<button
			type="button"
			className={cn(
				"card relative p-0 overflow-hidden cursor-pointer",
				isSelected && "border-primary-700! dark:border-accent-500!",
			)}
			onClick={() => onToggle(item.id)}
			data-cy="pick-project-gallery-files-item"
		>
			<div className="absolute top-1 right-1 z-10">
				<Checkbox
					value={isSelected}
					onChange={() => onToggle(item.id)}
				/>
			</div>
			{isImage ? (
				<div
					style={{
						height: "110px",
						aspectRatio: calculateAspectRatio(item.width, item.height),
					}}
				>
					<img
						src={item.signedUrl}
						className="object-cover w-full h-full"
						alt={item.fileName}
					/>
				</div>
			) : (
				<div
					className="w-max flex flex-row items-center px-4 grow-0 gap-4"
					style={{ height: "110px", maxWidth: "330px" }}
				>
					<FileIcon fileType={item.contentType} />
					<p className="line-clamp-1 whitespace-wrap break-all text-xs text-center">
						{item.fileName}
					</p>
				</div>
			)}
		</button>
	);
}
